module.exports = __webpack_public_path__ + "a79ef3e34468422859ee9b1ede8e8f98.jpg";